/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import Button from 'components/base/Button';
import { AnomalyRecord } from 'data/entities/AnomalyRecord';
import dayjs from 'dayjs';

import React, { useEffect, useRef, useState } from 'react';
import { UilArrowLeft, UilPrint } from "@iconscout/react-unicons";
import { Col, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { useTranslation } from "react-i18next";
import "react-datepicker/dist/react-datepicker.css";
import { DatabaseService } from './stores/DatabaseService';
import {
	classifyRisk,
	equipmentComponentGroupMap,
	parseDate,
	THERMAL_ANOMALY,
	THERMAL_RECORD
} from './Utils';

import { IPlant as PowerStation } from 'pages/thermography/model/plant.model';
import { useNavigate, useParams } from 'react-router-dom';
import { IEquipment } from 'pages/thermography/model/equipment.model';
import { IEquipmentComponent } from './model/equipment-component.model';
import { EquipmentType } from './model/enumerations/equipment-type.model';
import ThermalAnalysisDataInfo from './ThermographicInspectionRecord/ThermalAnalysisDataInfo';
import ThermalRegistrationDataInfo from './ThermographicInspectionRecord/ThermalRegistrationDataInfo';
import { IInspectionRecord } from './model/inspection-record.model';
import { IRiskPeriodicityDeadline } from './model/risk-periodicity-deadline.model';


interface ThermalAnomalyEquipmentInfoProps {
	className?: string;
	mode: string | null;
	anomalyRecord: AnomalyRecord;
	setAnomalyRecord: React.Dispatch<React.SetStateAction<AnomalyRecord>>;
	saveAnomalyEquipmentInfo: () => Promise<void>;
	deltaT: number
}

const ThermalAnomalyEquipmentInfo = ({
	mode,
	anomalyRecord,
	setAnomalyRecord,
	saveAnomalyEquipmentInfo,
	deltaT = 0

}: ThermalAnomalyEquipmentInfoProps) => {
	const dbService = DatabaseService.getInstance();
	const { t } = useTranslation();
	const tt = (key: string, options?: Record<string, unknown>) => t(key, { ns: "translation", ...options });
	const powerStations = dbService.getPowerStations().sort((a, b) => { return a.name.localeCompare(b.name) });
	const equipments = dbService.getEquipments();
	const inspectionRoutes = dbService.getInspectionRecords();
	const thermographers = dbService.getThermographers();
	const equipmentComponents = dbService.getEquipmentComponents().toSorted((a, b) => (a.name || '').localeCompare(b.name || ''));
	const riskPeriodDeadlineList = dbService.getRiskPeriodicityDeadline();
	const anomalyRecords = dbService.getAnomalyRecords();

	const navigate = useNavigate();

	const [powerStation, setPowerStation] = useState<PowerStation | null>(null);
	const [equipmentsFiltered, setEquipmentsFiltered] = useState<IEquipment[] | []>([]);
	const [inspectionRoutesFiltered, setInspectionRoutesFiltered] = useState<IInspectionRecord[] | []>([]);
	const [equipmentType, setEquipmentType] = useState('');
	const [equipmentComponentsFiltered, setEquipmentComponentsFiltered] = useState<IEquipmentComponent[] | []>([]);
	const [validated, setValidated] = useState(false);
	const hasInitializedRiskTextRef = useRef(false);

	useEffect(() => {
		if (mode == "new") {
			const interval = setInterval(() => {
				setAnomalyRecord(prev => ({

					...prev,
					createdAt: dayjs(),
				}));
			}, 1000);

			return () => clearInterval(interval);
		}

	}, []);


	useEffect(() => {
		if (anomalyRecord.plant?.id)
			handlePowerStationChange(anomalyRecord.plant.id);
	}, [anomalyRecord.plant?.id]);

	useEffect(() => {
		if (anomalyRecord.equipment?.id)
			handleEquipmentChange(anomalyRecord.equipment?.id);
	}, [anomalyRecord.equipment?.id]);

	useEffect(() => {

		setAnomalyRecord(prev => ({
			...prev,
			["deltaT"]: deltaT
		}));

		handleDeltaTChange(deltaT);

	}, [deltaT]);

	useEffect(() => {
		// Enquanto não houver os 3 dados, apenas aguarda (não limpa no carregamento)
		if (!anomalyRecord.equipment?.id || !anomalyRecord.component?.id || !anomalyRecord.condition) {
			return;
		}

		// Primeira vez que a combinação completa estiver pronta (carregamento): não sobrescreve texto existente
		if (!hasInitializedRiskTextRef.current) {
			hasInitializedRiskTextRef.current = true;
			return;
		}

		// Se tiver condition, buscar o riskPeriodDeadline correspondente e atualizar
		if (anomalyRecord.condition) {
			const riskPeriodDeadline = riskPeriodDeadlineList.find(x => x.name === anomalyRecord.condition);
			
			if (riskPeriodDeadline) {
				// Buscar os objetos completos para garantir que temos os nomes atualizados
				const currentEquipment = equipments.find(e => e.id === anomalyRecord.equipment?.id);
				const currentComponent = equipmentComponents.find(c => c.id === anomalyRecord.component?.id);
				
				   setAnomalyRecord(prev => ({
					   ...prev,
					   recommendations: riskPeriodDeadline.recommendations ?? '',
					   analysisDescription: (riskPeriodDeadline.description ?? "")
						   .replace(
							   "@COMPONENT",
							   currentComponent?.name ? `"${currentComponent.name ?? ""}"` : ""
						   )
						   .replace(
							   "@EQUIPMENT",
							   currentEquipment
								//    ? `"${currentEquipment.code.split("-").pop()} (${currentEquipment.name})"`
								   ? `"${currentEquipment.code} (${currentEquipment.name})"`
								   : ""
						   )
				   }));
			}
		}
	}, [anomalyRecord.equipment?.id, anomalyRecord.component?.id, anomalyRecord.condition]);

	const onInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
		const { name, value, type } = e.target;
		let formatedValue;


		if (type === 'number')
			formatedValue = value === '' ? '' : parseFloat(value);
		else if (name == 'createdAt' || name == 'deadlineExecution')
			formatedValue = parseDate(value)
		else
			formatedValue = value;

		setAnomalyRecord(prev => ({
			...prev,
			[name]: formatedValue
		}));
	};

	const ID_NAME_TO_OBJECT_KEY: Record<string, string> = {
		plantId: "plant",
		equipmentId: "equipment",
		routeId: "route",
		component: "component",
		thermographerId: "createdBy"
	};

	const onSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const { name, value, selectedIndex, options } = e.target;

		const selectedOption = options[selectedIndex];
		const typeAttr = selectedOption.getAttribute('data-type');

		let formattedValue: any;

		if (typeAttr === 'number') {
			formattedValue = value === '' ? -1 : parseInt(value, 10);
		} else if (typeAttr === 'float') {
			formattedValue = value === '' ? -1 : parseFloat(value);
		} else {
			formattedValue = value;
		}

		setAnomalyRecord(prev => {
			const objKey = ID_NAME_TO_OBJECT_KEY[name];

			if (objKey) {
				return {
					...prev,
					[objKey]: {
						...(prev as any)[objKey],
						id: formattedValue,
					},
				};
			}

			return {
				...prev,
				[name]: formattedValue,
			};
		});
	};

	const handleDeadlineExecutionChange = (date: Date | null) => {
		const formattedDate = date ? dayjs(date) : null; // Convert to Dayjs instance
		setAnomalyRecord({ ...anomalyRecord, deadlineExecution: formattedDate });
	};

	const handlePowerStationChange = (value: String) => {

		let powerStation = powerStations.find(powerStation => powerStation.id == value);
		if (powerStation) {
			setPowerStation(powerStation);
			setEquipmentsFiltered(equipments.filter(x => x.plant?.id == powerStation.id));
			setInspectionRoutesFiltered(inspectionRoutes.filter(x => x.plant?.id == powerStation.id));
			setEquipmentType('')
			setThermalRecordId(powerStation, null);
		}
		else {
			setEquipmentsFiltered([]);
			setInspectionRoutesFiltered([]);
			setEquipmentType('')
			setThermalRecordId(null, null);
		}
	}

	const setThermalRecordId = (powerStation: PowerStation | null, condition: string | null) => {

		if (powerStation) {

			let lastName = powerStation ? powerStation.code.split('-').pop() : '';
			let newCondition = condition ? condition : "normal";

			if (newCondition.toLowerCase() == "normal") {
				let anomaly_records = anomalyRecords
					.filter(x =>
						x.plant?.id == powerStation?.id &&
						x.condition?.toLocaleLowerCase() == "normal");
				anomalyRecord.name = anomaly_records ? `${THERMAL_RECORD}_${anomaly_records.length + 1}_${lastName}` : '';
			}
			else {
				let anomaly_records = anomalyRecords
					.filter(x =>
						x.plant?.id == powerStation?.id &&
						x.condition?.toLocaleLowerCase() == "normal");
				let lastName = powerStation ? powerStation.code.split('-').pop() : '';
				anomalyRecord.name = anomaly_records ? `${THERMAL_ANOMALY}_${anomaly_records.length + 1}_${lastName}` : '';
			}
		}
		else {
			anomalyRecord.name = ''
		}
	}
	
	const handleEquipmentChange = (value: string) => {
		let equipment = equipments.find(x => x.id == value);

		if (equipment){
			setEquipmentType(`${equipment.code} (${equipment.name})`)	
			if(equipment.type != anomalyRecord.equipment?.type) {
				setAnomalyRecord(prev => ({
					...prev,
					component: null,
					recommendations: '',
					analysisDescription: ''		
				}));
			}		
		}
		else {
			setEquipmentType('')
		}

		let code = equipment?.type && equipmentComponentGroupMap.has(equipment?.type as EquipmentType)
			? equipmentComponentGroupMap.get(equipment?.type as EquipmentType)
			: '';
		let equipmentComponentsFiltered = equipmentComponents.filter(x => x.code == code);
		setEquipmentComponentsFiltered(equipmentComponentsFiltered);
		
	}

	const onComponentChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const { name, value } = e.target;
		let condition;
		let equipmentComponentLimit = equipmentComponents.find(x => x.id == value);

		if (anomalyRecord.deltaT && value.trim() != "") {			
			if (equipmentComponentLimit) {
				let conditionType = classifyRisk(anomalyRecord.deltaT, equipmentComponentLimit.componentTemperatureLimits);
				condition = riskPeriodDeadlineList.find(x => x.name == conditionType);
			}
		}
		else {
			condition = riskPeriodDeadlineList.find(x => x.name == "NORMAL");
		}

		if (condition) {
			anomalyRecord.condition = condition.name as "NORMAL" | "LOW_RISK" | "MEDIUM_RISK" | "HIGH_RISK" | "IMMINENT_HIGH_RISK";
			handleConditionChange(condition.name);
		}

		onSelectChange(e);
		// setToastValue(e.target);
		// setShow(true);
	}

	const onConditionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const { name, value } = e.target;

		handleConditionChange(value);
		onSelectChange(e);
	}

	const handleConditionChange = (value: string) => {
		setThermalRecordId(powerStation, value);
		let riskPeriodDeadline = riskPeriodDeadlineList.find(x => x.name.toString() === value);

		if (value.length === 0 || value.toLocaleLowerCase() === 'normal') {
			anomalyRecord.deadlineExecution = null;
			anomalyRecord.periodicity = -1;
			anomalyRecord.nextMonitoring = null;
		} else {
			let anomaly_records = anomalyRecords.filter(
				x => x.plant?.id === powerStation?.id &&
					x.condition?.toLocaleLowerCase() !== "normal"
			);
			let lastName = powerStation ? powerStation.code.split('-').pop() : '';
			anomalyRecord.name = anomaly_records ? `${THERMAL_ANOMALY}_${anomaly_records.length + 1}_${lastName}` : '';
			
			if (riskPeriodDeadline) {
				if (riskPeriodDeadline.deadline && riskPeriodDeadline.deadline > 0) {
					let date = anomalyRecord.createdAt ? dayjs(anomalyRecord.createdAt) : dayjs(); // Ensure it's a Dayjs instance
					if (date.isValid()) {
						if (riskPeriodDeadline.deadlineUnit && riskPeriodDeadline.deadlineUnit.toLocaleLowerCase().includes('hour')) {
							date = date.add(riskPeriodDeadline.deadline, 'hour');
						} else if (riskPeriodDeadline.deadlineUnit && riskPeriodDeadline.deadlineUnit.toLocaleLowerCase().includes('day')) {
							date = date.add(riskPeriodDeadline.deadline, 'day');
						} else if ((riskPeriodDeadline.deadlineUnit && riskPeriodDeadline.deadlineUnit.toLocaleLowerCase().includes('month')) 
							|| (riskPeriodDeadline.deadlineUnit && riskPeriodDeadline.deadlineUnit.toLocaleLowerCase().includes('months'))) {
							date = date.add(riskPeriodDeadline.deadline, 'month');
						} else if (riskPeriodDeadline.deadlineUnit && riskPeriodDeadline.deadlineUnit.toLocaleLowerCase().includes('year')) {
							date = date.add(riskPeriodDeadline.deadline, 'year');
						}
						anomalyRecord.deadlineExecution = date;
					}
				}
				if (riskPeriodDeadline.periodicity && riskPeriodDeadline.periodicity >= 0) {
					let days = -1;
					let date = dayjs(anomalyRecord.createdAt);
					if (riskPeriodDeadline.periodicityUnit && riskPeriodDeadline.periodicityUnit.toLocaleLowerCase().includes('day')) {
						days = riskPeriodDeadline.periodicity;
					} else if ((riskPeriodDeadline.periodicityUnit && riskPeriodDeadline.periodicityUnit.toLocaleLowerCase().includes('month')) || (riskPeriodDeadline.periodicityUnit && riskPeriodDeadline.periodicityUnit.toLocaleLowerCase().includes('months'))) {
						days = riskPeriodDeadline.periodicity * 30;
					} else if (riskPeriodDeadline.periodicityUnit && riskPeriodDeadline.periodicityUnit.toLocaleLowerCase().includes(' ser definido')) {
						days = 0;
					}
					if (days === -1 || days === 0) {
						anomalyRecord.periodicity = days;
						anomalyRecord.nextMonitoring = null;
					} else {
						anomalyRecord.periodicity = days;
						anomalyRecord.nextMonitoring = dayjs(date.add(days, 'day'));
					}
				}
			}
		}
	}

	const onDeltaTChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;

		let deltaT = value.length > 0 ? parseFloat(value) : 0;
		handleDeltaTChange(deltaT);
		onInputChange(e);
	}


	const handleDeltaTChange = (deltaT: number) => {
		let equipmentComponent = equipmentComponents.find(x => x.id == anomalyRecord.component?.id);
		if (equipmentComponent) {
			let conditionType = classifyRisk(deltaT, equipmentComponent.componentTemperatureLimits);
			let condition = riskPeriodDeadlineList.find(x => x.name == conditionType);

			if (condition) {
				anomalyRecord.condition = condition.name as "NORMAL" | "LOW_RISK" | "MEDIUM_RISK" | "HIGH_RISK" | "IMMINENT_HIGH_RISK";
				handleConditionChange(condition.name);
			}
		}
	}

	const onCancel = (e: React.MouseEvent<HTMLButtonElement>) => {
		navigate(-1);
	}

	const onSaveData = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		e.stopPropagation();

		const form = e.currentTarget;
		try {
			if (form.checkValidity() === true) {
				saveAnomalyEquipmentInfo();
			}
			else {
				setValidated(true);
			}
		} catch (error) {
			setValidated(true);
		}
	};

	const { codigo } = useParams<{ codigo?: string; }>();

	const onPrint = () => {
		navigate(`/thermalRecordForm/report/${codigo}`, {
			state: {
				anomalyRecord,
				deltaT
			}
		});
	};

	return (
		<div className="">
			<div className="d-flex align-items-center justify-content-between mb-1 mt-3 ps-4 pe-2">
				<h4 className="mb-0">{tt("pages.thermography.thermalAnomalyEquipmentInfo.title")}</h4>

				<div className="d-flex align-items-center gap-2">
					<Button
						variant="outline-primary"
						type="button"
						onClick={() => navigate(-1)}
						aria-label={tt("pages.thermography.thermalAnomalyEquipmentInfo.back")}
						title={tt("pages.thermography.thermalAnomalyEquipmentInfo.back")}
						className="d-inline-flex align-items-center justify-content-center"
						style={{ width: 38, height: 38, padding: 0 }}
					>
						<UilArrowLeft size={18} />
						<span className="visually-hidden">{tt("pages.thermography.thermalAnomalyEquipmentInfo.back")}</span>
						{/* se usar react-bootstrap-icons: <ArrowLeft size={18} /> */}
					</Button>

					<Button
						variant="primary"
						type="button"
						onClick={onPrint}
						aria-label={tt("pages.thermography.thermalAnomalyEquipmentInfo.viewPrint")}
						title={tt("pages.thermography.thermalAnomalyEquipmentInfo.viewPrint")}
						className="d-inline-flex align-items-center justify-content-center"
						style={{ width: 38, height: 38, padding: 0 }}
					>
						<UilPrint size={18} />
						<span className="visually-hidden">{tt("pages.thermography.thermalAnomalyEquipmentInfo.viewPrint")}</span>
						{/* se usar react-bootstrap-icons: <Printer size={18} /> */}
					</Button>
				</div>
			</div>
			<Form noValidate validated={validated} onSubmit={onSaveData}>
				<ThermalRegistrationDataInfo
					mode={mode}
					anomalyRecord={anomalyRecord}
					powerStations={powerStations}
					equipmentsFiltered={equipmentsFiltered}
					inspectionRoutesFiltered={inspectionRoutesFiltered}
					thermographers={thermographers}
					equipmentType={equipmentType}
					onSelectChange={onSelectChange}
					onInputChange={onInputChange}
				/>

				<ThermalAnalysisDataInfo
					mode={mode}
					anomalyRecord={anomalyRecord}
					equipmentComponentLimites={equipmentComponentsFiltered}
					riskPeriodDeadlineList={riskPeriodDeadlineList}
					onInputChange={onInputChange}
					onSelectChange={onSelectChange}
					onComponentChange={onComponentChange}
					onDeltaTChange={onDeltaTChange}
					onConditionChange={onConditionChange}
					handleDeadlineExecutionChange={handleDeadlineExecutionChange}
				/>

				<Row className="mt-3">

					<Col xs={12}>
						<div className="d-flex justify-content-center gap-3">
							<Button
								type='button'
								variant={mode !== "view" ? "phoenix-primary" : "primary"}
								className="px-5"
								onClick={onCancel}
							>
								{mode === "view"
									? tt("pages.thermography.thermalAnomalyEquipmentInfo.back")
									: tt("pages.thermography.thermalAnomalyEquipmentInfo.cancel")}
							</Button>

							{mode !== "view" && (
								<Button
									type='submit'
									variant="primary"
									className="px-5"
								// disabled={mode === "view"}
								>
									{tt("pages.thermography.thermalAnomalyEquipmentInfo.save")}
								</Button>
							)}
						</div>
					</Col>
				</Row>
			</Form>

		</div>
	);
};

export default ThermalAnomalyEquipmentInfo;
